import { ICertificateTemplate, IFontFamily } from '@/shared/model/certificate-template.model';
import axios from 'axios';

const baseApiUrl = 'api/internal/certificate-templates';

export default class CertificateTemplateService {

  public find(id: number, apiKey: string): Promise<ICertificateTemplate> {
    return axios
      .get<ICertificateTemplate>(`${baseApiUrl}/${id}`, { headers: { 'X-ELB-KEY': apiKey } })
      .then(res => res.data);
  }

  public create(template: ICertificateTemplate, apiKey: string): Promise<ICertificateTemplate> {
    return axios
      .post<ICertificateTemplate>(baseApiUrl, template, { headers: { 'X-ELB-KEY': apiKey } })
      .then(res => res.data);
  }

  public update(id: number, template: ICertificateTemplate, apiKey: string): Promise<ICertificateTemplate> {
    return axios
      .put<ICertificateTemplate>(`${baseApiUrl}/${id}`, template, { headers: { 'X-ELB-KEY': apiKey } })
      .then(res => res.data);
  }

  public remove(id: number, apiKey: string): Promise<void> {
    return axios
      .delete(`${baseApiUrl}/${id}`, { headers: { 'X-ELB-KEY': apiKey } })
      .then(() => undefined);
  }

  public retrieveByOrg(organizationId: string, apiKey: string): Promise<ICertificateTemplate[]> {
    return axios
      .get<ICertificateTemplate[]>(`${baseApiUrl}/by-org`, {
        params: { organizationId },
        headers: { 'X-ELB-KEY': apiKey },
      })
      .then(res => res.data);
  }

  public retrieve(apiKey: string, params: Record<string, string> = {}): Promise<ICertificateTemplate[]> {
    return axios
      .get<ICertificateTemplate[]>(baseApiUrl, {
        params: { 'isCustom.equals': 'true', ...params },
        headers: { 'X-ELB-KEY': apiKey },
      })
      .then(res => res.data);
  }

  public retrieveOriginals(apiKey: string, params: Record<string, string> = {}): Promise<ICertificateTemplate[]> {
    return axios
      .get<ICertificateTemplate[]>(baseApiUrl, {
        params: { 'isCustom.equals': 'false', ...params },
        headers: { 'X-ELB-KEY': apiKey },
      })
      .then(res => res.data);
  }

  public getFonts(apiKey: string): Promise<IFontFamily[]> {
    return axios
      .get<IFontFamily[]>(`${baseApiUrl}/fonts`, { headers: { 'X-ELB-KEY': apiKey } })
      .then(res => res.data);
  }

  public uploadBackground(file: File, organizationId: string, apiKey: string): Promise<string> {
    const form = new FormData();
    form.append('file', file);
    form.append('organizationId', organizationId);
    return axios
      .post<string>(`${baseApiUrl}/background-image`, form, {
        headers: { 'X-ELB-KEY': apiKey },
      })
      .then(res => res.data);
  }
}
